"use strict";
/**
 * This file defines an Iterator interface. It is a compatible, but simplified, version of the ES6 iterator interface. Even with the
 * downlevelIteration Typescript compiler flag, we can't use iterators on arbitrary objects without a symbol polyfill. Hence, for maximum
 * compatibility, these interfaces are redefined here so we don't have to rely on ES6 at compile time.
 *
 * Full type definitions can be found at:
 * https://github.com/Microsoft/TypeScript/blob/master/lib/lib.es2015.iterable.d.ts
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TypeScriptUtility_1 = require("./common/TypeScriptUtility");
/**
 * Smart constructor for creating an iterator result that is not done.
 *
 * @param value - The next value.
 */
function iteratorResultNotDone(value) {
    return {
        done: false,
        value: value
    };
}
exports.iteratorResultNotDone = iteratorResultNotDone;
/**
 * A value for representing an iterator result that is done.
 */
exports.iteratorResultDone = {
    done: true
};
/**
 * Higher-order helper function for iterator results.
 *
 * @param f - Function to apply to the next value.
 * @param t - Default value to return when applied to an iterator result that is done.
 */
function iteratorResult(f, t) {
    return function (ir) {
        switch (ir.done) {
            case false: return f(ir.value);
            case true: return t;
            default: return TypeScriptUtility_1.assertNever(ir);
        }
    };
}
exports.iteratorResult = iteratorResult;
/**
 * Returns the next value or throws an exception if given an iterator result that is done.
 *
 * @param ir - Iterator result.
 * @throws Error if given an iterator result that is done.
 */
function fromIteratorResultNotDone(ir) {
    switch (ir.done) {
        case false: return ir.value;
        default: throw new Error('IteratorResultDone');
    }
}
exports.fromIteratorResultNotDone = fromIteratorResultNotDone;
/**
 * Returns the next value or a given default if applied to an iterator result that is done.
 *
 * @param t - Default value.
 */
function fromIteratorResult(t) {
    return iteratorResult(function (v) { return v; }, t);
}
exports.fromIteratorResult = fromIteratorResult;
//# sourceMappingURL=Iterator.js.map